// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1dB44","input":"styles__input___3rBcD","createNewButton":"styles__createNewButton___1JyAV","label":"styles__label___1a4Kr"};